import { Address } from './address';

export class AuxiliaryContact
{
    id: number;
    type: string;
    unitId: number|null;
    name: string;
    email: string;
    phone: string;
    ownersCanView: boolean = false;
    ownersCanEdit: boolean = false;
    address: Address;

    constructor(contact: any) {
        if (contact.id) {
            this.id = contact.id;
        }

        if(contact.contactableType === 'App\\Models\\Entities\\Unit') {
            this.unitId = contact.contactableId;
        }

        this.type = contact.contactableType || 'unit';

        if (contact.name) {
            this.name = contact.name;
        }

        this.email = contact.email;

        this.phone = contact.phone;

        if(contact.ownersCanView) {
            this.ownersCanView = contact.ownersCanView;
        }

        if(contact.ownersCanEdit) {
            this.ownersCanEdit = contact.ownersCanEdit;
        }

        if (contact.address) {
            this.address = new Address(contact.address);
        }
    }
}
